import React, { useState } from "react";
import AppRouter from "./components/Routing";
import Header from "./components/HeaderFooter/header";
import Footer from "./components/HeaderFooter/footer";
import { BrowserRouter } from "react-router-dom";

const App = () => {
  return <AppRouter />;
};
export default App;
